module.exports = require("babel-core/register");



/*****************
 ** WEBPACK FOOTER
 ** ./~/babel/register.js
 ** module id = 535
 ** module chunks = 0
 **/